// export const baseUrl = "http://localhost:9799/api/v1";
export const baseUrl = "http://3.109.110.211/api/v1";

export const token = localStorage.getItem("token");
 